import {
    Chart,
    LineElement,
    PointElement,
    LineController,
    CategoryScale,
    LinearScale,
    Legend,
    Tooltip,
} from 'chart.js';

Chart.register(LineElement, PointElement, LineController, CategoryScale, LinearScale, Legend, Tooltip);

export default $wire => ({
    isOpen: false,
    data: $wire.entangle('data').live,
    labels: $wire.entangle('labels').live,
    evolutionLabel: $wire.entangle('evolutionLabel').live,
    priceEvolutionTrendLine: $wire.entangle('priceEvolutionTrendLine').live,
    showPriceEvolutionTrendLine: $wire.entangle('showPriceEvolutionTrendLine').live,
    open() {
        this.isOpen = true;
    },
    close() {
        this.isOpen = false;
    },
    init() {
        const ctx = 'market-trend';
        const datasets = [];
        const colors = ['#B81C24', '#006FBC', '#A36DD0'];

        const getOrCreateLegendList = (chart, id) => {
            const legendContainer = document.getElementById(id);
            let listContainer = legendContainer.querySelector('ul');

            if (!listContainer) {
                listContainer = document.createElement('ul');
                listContainer.style.display = 'flex';
                listContainer.style.flexDirection = 'row';
                listContainer.style.margin = 0;
                listContainer.style.padding = 0;
                listContainer.style.flexWrap = 'wrap';
                listContainer.style.rowGap = '10px';
                listContainer.style.justifyContent = 'space-between';

                legendContainer.appendChild(listContainer);
            }

            return listContainer;
        };

        const htmlLegendPlugin = {
            id: 'htmlLegend',
            afterUpdate(chart, args, options) {
                const ul = getOrCreateLegendList(chart, options.containerID);

                // Remove old legend items
                while (ul.firstChild) {
                    ul.firstChild.remove();
                }

                // Reuse the built-in legendItems generator
                const items = chart.options.plugins.legend.labels.generateLabels(chart);

                items.forEach(item => {
                    const li = document.createElement('li');
                    li.style.alignItems = 'center';
                    li.style.cursor = 'pointer';
                    li.style.display = 'flex';
                    li.style.flexDirection = 'row';
                    li.style.marginLeft = '10px';

                    li.onclick = () => {
                        chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                        chart.update();
                    };

                    // Color box
                    const boxSpan = document.createElement('span');
                    boxSpan.style.background = item.fillStyle;
                    boxSpan.style.backgroundColor = item.backgroundColor;
                    boxSpan.style.display = 'inline-block';
                    boxSpan.style.height = '20px';
                    boxSpan.style.marginRight = '10px';
                    boxSpan.style.width = '20px';

                    // Text
                    const textContainer = document.createElement('p');
                    textContainer.style.color = item.fontColor;
                    textContainer.style.margin = 0;
                    textContainer.style.padding = 0;
                    textContainer.style.textDecoration = item.hidden ? 'line-through' : '';

                    const text = document.createTextNode(item.text);
                    textContainer.appendChild(text);

                    li.appendChild(boxSpan);
                    li.appendChild(textContainer);
                    ul.appendChild(li);
                });
            },
        };

        Object.values(this.data)
            .filter(value => value.display === true)
            .forEach(function (data, index) {
                datasets.push({
                    label: data.label,
                    data: data.data,
                    fill: true,
                    backgroundColor: colors[index],
                    borderColor: colors[index],
                    tension: 0.4,
                    cubicInterpolationMode: 'monotone',
                });
            });

        if (this.showPriceEvolutionTrendLine) {
            datasets.push({
                label: this.evolutionLabel,
                data: this.priceEvolutionTrendLine,
                fill: true,
                backgroundColor: 'green',
                borderColor: 'green',
                tension: 0.4,
                cubicInterpolationMode: 'monotone',
            });
        }

        const config = {
            type: 'line',
            data: {
                labels: this.labels,
                datasets: datasets,
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                stacked: false,
                scales: {
                    y: {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        beginAtZero: true,
                    },
                },
                plugins: {
                    legend: { display: false },
                    htmlLegend: { containerID: 'market-trend-legend-container' },
                },
            },
            plugins: [htmlLegendPlugin],
        };

        new Chart(ctx, config);
    },
});
